__turbopack_context__.v({
  "container": "index-module__0dn9tG__container",
  "cubeChemIconWrapper": "index-module__0dn9tG__cubeChemIconWrapper",
  "globePiIconWrapper": "index-module__0dn9tG__globePiIconWrapper",
  "marquee": "index-module__0dn9tG__marquee",
  "marqueeChild": "index-module__0dn9tG__marqueeChild",
  "marqueeGradient": "index-module__0dn9tG__marqueeGradient",
  "marqueeParent": "index-module__0dn9tG__marqueeParent",
  "mathIconWrapper": "index-module__0dn9tG__mathIconWrapper",
});
